import { doc, getDoc, updateDoc, increment } from 'firebase/firestore';
import { db } from './firebase';

export async function getTotalCreationsCount(userId: string, type: 'bits' | 'ideas'): Promise<number> {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (!userDoc.exists()) return 0;
    
    const data = userDoc.data();
    return type === 'bits' ? (data.totalBitsCreated || 0) : (data.totalIdeasCreated || 0);
  } catch (error) {
    console.error(`Error getting ${type} count:`, error);
    return 0;
  }
}

export async function incrementCreationCount(userId: string, type: 'bits' | 'ideas'): Promise<void> {
  try {
    const field = type === 'bits' ? 'totalBitsCreated' : 'totalIdeasCreated';
    await updateDoc(doc(db, 'users', userId), {
      [field]: increment(1)
    });
  } catch (error) {
    console.error(`Error incrementing ${type} count:`, error);
    throw error;
  }
}

export const FREE_TIER_LIMIT = 10;
